/**
 * Global glass surfaces: #141414 base + frosted blur (see `index.css` @layer components).
 * Compose with `rounded-*`, `overflow-hidden`, padding, etc.
 */
export const glassSurface = 'glass-surface'
export const glassSurfaceSoft = 'glass-surface-soft'
export const glassHeader = 'glass-header'
export const glassHeaderDrawer = 'glass-header-drawer'
export const glassPodiumGold = 'glass-podium-gold'
export const glassPodiumSilver = 'glass-podium-silver'
export const glassPodiumBronze = 'glass-podium-bronze'
